import React, {useState, useEffect, useCallback} from 'react'
import {Spinner} from '@material-tailwind/react'
import { debounce } from 'lodash';
import toast, { Toaster } from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from '@heroicons/react/24/solid';

import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding } from '../../configs/constant.js';
import { Input } from '@material-tailwind/react'
import { formatAddress } from '../../util/format-data.js'
import { registerRunesPayment, latestTokenNew, checkWhiteListedAddress, registerTokenNew, getPaymentTx, getPaymentUtxosRunes, getPaymentHistoryNew, savePaymentHistoryNew, getSignMintTextNew, getMintStatus, checkWhiteListedDomain } from '../../util/new-api.js'
import { getAsciiSum } from '../../util/format-data.js';
import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, waitSomeSeconds, pushBTCpmt } from '../../util/inscribe-util.js';
import FeeRateCard from '../../components/FeeRateCard.js';
import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { latestDmtTokenRandom, latestTokenRandom, checkRuneName } from '../../util/new-api.js';
import {mintAlkanesStart, mintAlkanesCancel, mintAlkanesPrepare, mintAlkanesFunded, registerAlkanesLoyalty, getAlkanesLoyalty} from '../../util/alkanes-api.js';
import RuneTopIndexer from '../../components/Rune/RuneTopIndexer.js';
import { postUnisatTransaction } from '../../util/api.js';
import { broadcastBitcoinTransaction } from '../../util/new-api.js';
import alkanesImg from '../../assets/imgs/alkanes.png';
import cheekyImg from '../../assets/imgs/cheeky.png';
import { isValidTaprootAddress } from '../../util/inscribe-util.js';
import { registerReferalCode, registerReferalHistory, getReferalHistory, referalCodeCheck, getReferalParentAddress } from '../../util/refer-api.js'
import { launchpadTokenRandom } from '../../util/new-api.js';
import { formatFloat } from '../../util/format-data.js';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter
} from "@material-tailwind/react";

import { useWallet, useWallets } from '@wallet-standard/react';
import { savePointData } from '../../util/api.js';
import { useTranslation } from 'react-i18next';
import AlkanesTopIndexer from '../../components/Rune/AlkanesTopIndexer.js';
import { getAlkanesTopMint } from '../../util/alkanes-api.js';
import { getAlkanesKey } from '../../util/alkanes-api.js';
import { useParams } from 'react-router-dom';
import ReferalCard from '../../components/ReferalCard.js';
import { useNavigate } from 'react-router-dom';

import cheekyGif from '../../assets/imgs/cheeky.gif'
import referImg from '../../assets/imgs/referal.png'
import leaderboardImg from '../../assets/imgs/leaderboard2.png'
import oylzeroImg from '../../assets/imgs/oylzero.png'

export default function MintAlkanesTest() {
  const { param } = useParams();
  const { wallets } = useWallets();
  const navigate = useNavigate();

  const SatsConnectNamespace = 'sats-connect:';

  const prices = useSelector(state => state.price);

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const { t, i18n } = useTranslation();
  const wallet = useSelector(state => state.wallet);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const [feeRates, setFeeRates] = useState({});
  const [feeValues, setFeeValues] = useState({
    "inscribeFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "referFee": 0,
    "totalFee": 0
  });
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [domain, setDomain] = useState('');
  const [amount, setAmount] = useState(1);
  const [maximum, setMaximum] = useState(10000);
  const [sum, setSum] = useState(0);
  const [deployLimit, setDeployLimit] = useState(10000);
  const [address, setAddress] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [key, setKey] = useState('');
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [runeId, setRuneId] = useState(location.pathname.includes("earn") ? "" : param);
  const [inscriptionStatus, setInscriptionStatus] = useState(false);
  const [isRoyalty, setIsRoyalty] = useState(1);
  const [totalFees, setTotalFees] = useState(0);
  const [runeName, setRuneName] = useState('');
  const [codeIsValid, setCodeIsValid] = useState(false);
  const [referalAddress, setReferalAddress] = useState('');
  const [showReferalCard, setShowReferalCard] = useState(false);
  const [loyaltyTotal, setLoyaltyTotal] = useState(0);
  const [loyaltyPercent, setLoyaltyPercent] = useState(1);

  useEffect(() => {
    const checkCode = async (code) => {
      const result = await referalCodeCheck(code);
      setCodeIsValid(result.status == "success" ? true : false);
      if (result.status == "success") {
        setReferalAddress(result.address);
      }
    }

    if (param != null && !location.pathname.includes("earn")) {
      debouncedSearch(param);
    }

    if (location.pathname.includes("earn")) {
      const code = location.pathname.split("/earn/")[1];
      checkCode(code);
    }
  }, [param, location.pathname]);

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(customFee);
        }
        else
        {
          let response = await getFeeRate();
          setFeeRates(response);
          setFeerate(response[feeRateMode]);
          if (customFee == 0) 
          {
            setCustomFee(response["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
    intervalId = setInterval(updateFees, 20 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [feeRateMode, customFee, isRoyalty])

  useEffect(() => {
    const updateFees = async () => {
      let tempFeeRate = parseFloat(feerate);
      if (tempFeeRate == 0) {
        let response = await getFeeRate();
        tempFeeRate = response[feeRateMode];
      }

    }
    updateFees();
  }, [amount])

  useEffect(() => {
    let tempFeeRate = parseFloat(feerate);
    let extra = 24;
    const totalFeeRate1 = 129;
    const totalFeeRate2 = 141;
    const outputValue = 330;
    const taprootOutputFee = 43;
    const maximumLimit = 24;

    let tempFundingAmount = 0;
    let tempReferalAmount = 0;

    if (amount > 2300) {
      tempFundingAmount = 60000;
      tempReferalAmount = 15000;
    }
    else if (amount > 2000) {
      tempFundingAmount = 50000;
      tempReferalAmount = 12500;
    }
    else if (amount > 1600) {
      tempFundingAmount = 40000;
      tempReferalAmount = 10000;
    }
    else if (amount > 1200) {
      tempFundingAmount = 30000;
      tempReferalAmount = 7500;
    }
    else if (amount > 800) {
      tempFundingAmount = 25000;
      tempReferalAmount = 6250;
    }
    else if (amount > 500) {
      tempFundingAmount = 20000;
      tempReferalAmount = 4000;
    }
    else if (amount > 200) {
      tempFundingAmount = 15000;
      tempReferalAmount = 3750;
    }
    else if (amount > 100) {
      tempFundingAmount = 10000;
      tempReferalAmount = 2500;
    }
    else if (amount > 50) {
      tempFundingAmount = 7500;
      tempReferalAmount = 1875;
    }
    else if (amount > 24) {
      tempFundingAmount = 5000;
      tempReferalAmount = 1250;
    }
    else if (amount > 5) {
      tempFundingAmount = 2000;
      tempReferalAmount = 0;
    }
    
    tempFundingAmount = Math.ceil(tempFundingAmount * loyaltyPercent);
    tempReferalAmount = Math.ceil(tempReferalAmount * loyaltyPercent);

    let count = Math.ceil(amount / maximumLimit);
    let inscribeFee = outputValue * count;
    let serviceFee = tempFundingAmount;
    let referFee = 0;
    let networkFee = 0;

    let cnt = maximumLimit;
    for(let i = 1; i <= count; i++)
    {
      if (i == count) cnt = amount - (maximumLimit * (count - 1));
      let tempFees = Math.ceil((cnt - 1) * (totalFeeRate1 + extra) * tempFeeRate) + Math.ceil((totalFeeRate2 + extra) * tempFeeRate);
      networkFee += tempFees;
    }

    networkFee += Math.ceil((57 + 43.5 + 43.5) * tempFeeRate);

    if (codeIsValid) {
      serviceFee = tempFundingAmount - tempReferalAmount;
      referFee = tempReferalAmount;
    }

    setTotalFees(
      {
        "inscribeFee": inscribeFee,
        "serviceFee": serviceFee,
        "referFee": referFee,
        "networkFee": networkFee,
        "totalFee": inscribeFee + serviceFee + referFee + networkFee
      }
    )
  }, [feerate, amount, codeIsValid, isRoyalty])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  useEffect(() => { 
    setAddress(wallet.nostrOrdinalsAddress);
    handleCheckRoyalty(wallet.nostrOrdinalsAddress);
    handleRoyalty(wallet.nostrPaymentAddress);
  }, [wallet.nostrOrdinalsAddress]);

  useEffect(() => { 
    if (loyaltyTotal > 1000000) {
      setLoyaltyPercent(0.3);
    }
    else if (loyaltyTotal > 500000) {
      setLoyaltyPercent(0.5);
    }
    else if (loyaltyTotal > 250000) {
      setLoyaltyPercent(0.65);
    }
    else if (loyaltyTotal > 100000) {
      setLoyaltyPercent(0.75);
    }
    else {
      setLoyaltyPercent(1);
    }
  }, [loyaltyTotal])

  const handleRoyalty = async(value) => {
    if (value == '') {
      setLoyaltyTotal(0);
    }
    else {
      let results = await getAlkanesLoyalty(value)
      if (results.status == "success") {
        if (results.total == null) {
          setLoyaltyTotal(0);
        }
        else {
          setLoyaltyTotal(parseInt(results.total));
        }
      }
      else {
        setLoyaltyTotal(0);
      }
    }
  }

  const handleCheckRoyalty = async (targetAddress) => {
    if (!location.pathname.includes('earn')) {
      let result = await getReferalParentAddress(targetAddress);
      if (result.status == "success") {
        setReferalAddress(result.data);
        setCodeIsValid(true);
      }
      else {
        setCodeIsValid(false);
        setReferalAddress("");
      }
    }
  }

  const handleMint = async () => {
    setLoading(true);

    if (wallet.nostrOrdinalsAddress == "")
    {
      toast.error(t('Connect Wallet Error Message'));
      setLoading(false);
      return;
    }

    if (address == "") {
      toast.error(t('Insert Inscription Address Error Message'));
      setLoading(false);
      return;
    }

    if (amount <= 0 ) {
      toast.error(t('Insert Amount Error Message'));
      setLoading(false);
      return;
    }

    if (amount > 2400) {
      toast.error(t('Maximum Mint Amount Error Message'))
      setLoading(false);
      return;
    }

    if (runeId == "") {
      toast.error(t('Insert ID Error Message'));
      setLoading(false);
      return;
    }

    let tempParams = {
      query: runeId,
      page: 1,
      limit: 10,
      order: "idAsc",
      active: null
    }

    let tempResults = await getAlkanesTopMint(tempParams);
    if (tempResults.data.total == 0 || tempResults.data.records[0].id != runeId || runeId == "2:0") {
      toast.error(t('Insert Valid ID Error Message'));
      setLoading(false);
      return;
    }

    if (tempResults.data.records[0].mintActive == 0) {
      toast.error(t('Mint Not Active Error Message'));
      setLoading(false);
      return;
    }

    let runesResult = await getAlkanesKey(parseInt(runeId.split(':')[0]), parseInt(runeId.split(':')[1]));

    let runekey = runesResult.key;
    let newRuneKey = runesResult.newKey;

    setLoading(false);
    setShow(true);
    setInscriptionStatus(false);
    
    const results = await getPaymentHistoryNew();
    const toggleValue = results[0].value;
    let fundingAddress = '';

    if (toggleValue == 0)
      fundingAddress = tippingAddress;
    else
      fundingAddress = ownerAddress;

    let isSuccess = true;

    const fundResults = await mintAlkanesPrepare(runekey, newRuneKey, amount, address, 330, feerate);

    let inscriptionAddressList = [];
    let inscriptionFee = [];

    for(let temp of fundResults.data)
    {
      inscriptionAddressList.push(temp.fundAddress);
      inscriptionFee.push(temp.fee);
    }

    let serviceFee = parseInt(totalFees.serviceFee);

    if (parseInt(totalFees.referFee) > 0 && referalAddress != wallet.nostrPaymentAddress) {
      inscriptionAddressList.push(referalAddress);
      inscriptionFee.push(parseInt(totalFees.referFee));
    }
    else {
      serviceFee += parseInt(totalFees.referFee);
    }

    let tempfeerate = parseFloat(feerate);
        
    if (wallet.domain == "xverseWallet") tempfeerate = Math.ceil(feerate * 1.2);

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      tempfeerate = 1.1;
    }

    const paymentUtxos = await getPaymentUtxosRunes(wallet.nostrPaymentAddress, inscriptionAddressList, inscriptionFee, fundingAddress, 0, wallet.paymentPublicKey, tempfeerate, inscriptionAddressList.length, wallet.domain)

    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      await mintAlkanesCancel(fundResults.randomKey);
      return;
    }

    try{
      if (wallet.domain == "oyl") {
        const txid = await window.oyl.signPsbt({ 
          psbt: paymentUtxos.hex,  
          broadcast: true
        })
      }
      else if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
                await mintAlkanesCancel(fundResults.randomKey);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          await mintAlkanesCancel(fundResults.randomKey);
          return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {   
            },
            onCancel: async () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
                await mintAlkanesCancel(fundResults.randomKey);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          await mintAlkanesCancel(fundResults.randomKey);
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        setShow(false);
        await mintAlkanesCancel(fundResults.randomKey);
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      setShow(false);
      await mintAlkanesCancel(fundResults.randomKey);
      return;
    }

    if (isSuccess) {
      let transactionData;
      await mintAlkanesFunded(fundResults.randomKey);

      if (codeIsValid && parseInt(totalFees.referFee) > 0) {
        await registerReferalHistory(
          {
            code : location.pathname.split("/earn/")[1],
            targetAddress: wallet.nostrOrdinalsAddress,
            sats: parseInt(totalFees.referFee),
            service: "alkanes mint"
          }
        )
      }

      await registerAlkanesLoyalty(wallet.nostrPaymentAddress, parseInt(totalFees.totalFee));

      while(true)
      {
        transactionData = await getMempoolUtxos(inscriptionAddressList[0]);
        if ( transactionData != undefined && transactionData.length >= 1){
          break;
        }
        await waitSomeSeconds(3);
      }

      let paramDatas = [];
      for(let i = 0; i < fundResults.data.length; i++) {
        paramDatas.push({
          txid : transactionData[0].txid,
          vout : i,
          value : inscriptionFee[i],
          fundAddress : inscriptionAddressList[i]
        })
      }

      let errorFlag = false;

      while(true) {
        if (paramDatas.length == 0) break;
        let resDatas = await mintAlkanesStart(fundResults.randomKey, paramDatas);
        paramDatas = [];
        console.log(resDatas);
        for(let resData of resDatas) {
          let txid = "";
          while(true) {
            //txid = await pushBTCpmt(resData.hex);
            try {
              await waitSomeSeconds(1);
              txid = await broadcastBitcoinTransaction(resData.hex);
              if (txid.length == 64) break;
              await waitSomeSeconds(5);
              txid = await postUnisatTransaction(resData.hex);
              if (txid.length == 64) break;
            }
            catch(e) {
              console.log(e);
            }
            errorFlag = true;
            break;
          }

          if (errorFlag) break;

          let tempVout = 1;
          if (runekey.length >= 28) tempVout = 0;

          if (resData.value > 0) {
            paramDatas.push({
              txid : txid,
              vout : tempVout,
              value : resData.value,
              fundAddress : resData.fundAddress
            })
          }
        }
        if (errorFlag) break;
      }

      await savePaymentHistoryNew(1 - toggleValue);
      await handleRoyalty(wallet.nostrPaymentAddress);
      setLoading(false);
      setInscriptionStatus(true);
    }
  }

  const calculateFeeReal = (fee, amount) => {

    const baseTxSize = 10;
    const inSize = 57.5;
    const outSize = 43;
    const txSize = baseTxSize + inSize * 1 + outSize * 2;

    let mintFee = Math.floor(fee * txSize) + 330;
    let networkFee = mintFee * amount;
  
    let royaltyFee = 10000 * isRoyalty;
    let totalFee = networkFee + royaltyFee;
    return {
      "mintFee": mintFee,
      "networkFee": networkFee,
      "royaltyFee": royaltyFee,
      "totalFee": totalFee
    }
  }

  const handleRuneId = (value) => {
    setRuneId(value);
    debouncedSearch(value);
  };
  
  const debouncedSearch = useCallback(debounce( async (value) => {
    try {
      let tempParams = {
        query: value,
        page: 1,
        limit: 10,
        order: "idAsc",
        active: null
      }
  
      let tempResults = await getAlkanesTopMint(tempParams);
      if (tempResults.data.total > 0 && tempResults.data.records[0].id == value) {
        setRuneName(tempResults.data.records[0].name);
      }
      else {
        setRuneName("");
      }
    }
    catch (e) {
      console.log(e);
    }
  }, 500), []); 

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleSliderAmount = (value) => {
    setAmount(parseInt(value * 24))
  }

  const checkBitcoinAddress = () => {
    let path = window.location.pathname;
    let address = path.split('/earn/')[1];
    if (address != null && address != "") {
      if (isValidTaprootAddress(address)) {
        return true;
      }
      else {

      }
    }
    return false;
  }

  const handleShowReferalCard = () => {
    if (wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Please connect your wallet'));
      return;
    }
    setShowReferalCard(true);
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col justify-center items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed" color="pink"/> : <></>
      }
      <div className="text-white font-semibold sm:text-[30px] text-[20px] sm:mt-[80px] mt-[30px] text-center bg-primary py-1 px-4 rounded-md font-title flex flex-row gap-2 items-center">
        <img src={alkanesImg} className="sm:w-[80px] sm:h-[80px] w-[60px] h-[60px]"/>
        <span>{t('Mint Alkanes')}</span>
        <img src={cheekyImg} className="sm:w-[80px] sm:h-[80px] w-[60px] h-[60px]"/>
      </div>
      <div className="flex md:flex-row flex-col gap-3 items-start ">
        <AlkanesTopIndexer handle = {(value) => {handleRuneId(value)} }/>
        <ReferalCard setShowReferalCard={setShowReferalCard} showReferalCard={showReferalCard}/>
        <div className="md:min-w-[500px] md:w-[600px] min-w-[300px] flex flex-col gap-2 md:mt-[55px] mt-5 w-full">
          <div className="flex flex-row w-full md:w-[600px] gap-2 p-2 justify-center items-center bg-primary rounded-md hover:bg-primary-hover cursor-pointer" onClick={() => navigate('/alkanes/leaderboard')}>
            <img src={leaderboardImg} className="w-7 h-7"/>
            <div className="text-[20px] font-bold">{t('Referrer Leaderboard')}</div>
          </div>
          <div className="flex flex-row w-full md:w-[600px] gap-2 p-2 justify-center items-center bg-primary rounded-md hover:bg-primary-hover cursor-pointer" onClick={handleShowReferalCard}>
            <img src={referImg} className="w-7 h-7"/>
            <div className="text-[20px] font-bold">{t('Refer Header')}</div>
          </div>
          <div className="flex flex-row w-full md:w-[600px] gap-2 p-2 justify-center items-center border-[1px] border-primary border-solid rounded-md cursor-pointer">
            <div className="md:text-[18px] text-[14px] font-bold">
              <span>{t('30D Mint Volume:')}</span> {formatFloat(loyaltyTotal / Math.pow(10, 8), 5)} BTC → <span>{t('Discount')}:</span> {(1 - loyaltyPercent) * 100}%</div>
          </div>
          <div className="border-gray-800 border-[1px] border-solid sm:p-8 p-3 rounded-lg flex flex-col gap-8 bg-[#081817] md:w-[600px] w-full">
            {
              runeName != "" ? 
              <div className="flex flex-row gap-3 items-center">
                <div>{t('NAME')}:</div>
                <div>{runeName}</div>
              </div>
              :
              <></>
            }
            <div>
              <Input type="text" color="white" label = {t('ID')} className="w-full md:min-w-[400px] min-w-[250px]" value={runeId} onChange = {(e) => {handleRuneId(e.target.value)}}/>
            </div>
            <div>
              <Input type="text" color="white" label = {t('Receiver Address')} className="w-full md:min-w-[400px] min-w-[250px]" value={address} onChange = {(e) => {setAddress(e.target.value)}}/>
            </div>
            <div className="flex flex-col">
              <div>{t('Repeat Mint Amount')}</div>
              <div className="flex flex-row gap-3 items-center">
                <Slider className="sm:flex hidden" color="blue" value = {amount / 24} onChange = {(e) => handleSliderAmount(e.target.value)}/>
                <div className="sm:max-w-[200px] w-full">
                  <Input type="text" color="white" label = {t('Amount')} className="sm:max-w-[200px] w-full" value={amount} onChange = {(e) => {setAmount(e.target.value)}}/>
                </div>
              </div>
            </div>
            <div className="sm:text-[18px] text-[14px]">
              {t('Select Network Fee You Want')}:
            </div>
            <div className="grid grid-cols-3 gap-3">
              <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
              <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
              <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
            </div>
            {
              feeRateMode == "Custom" ? 
              <div className="flex flex-row gap-3 items-center">
                <Slider className="sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
                <div className="sm:max-w-[200px] w-full">
                  <Input type="text" color="white" label = {t('Custom Fee')} className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
                </div>
              </div>
              : 
              <></>
            }
            <div className="m-auto md:w-[400px] w-full">
              <div className="flex flex-col mt-1 sm:text-[16px] text-[14px]">
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Inscribe Fee')}</div>
                  <div>{totalFees.inscribeFee / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees.inscribeFee) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Network Fee')}</div>
                  <div>{totalFees.networkFee / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees.networkFee) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>
                <div className="flex flex-row justify-between gap-1">
                  {
                    isRoyalty == 0 ?
                    <div>{t('Service Fee')} {t('(FREE with $OYLZERO)')}</div>
                    :
                    <div>{t('Service Fee')}</div>
                  }
                  
                  <div>{(parseInt(totalFees.serviceFee) + parseInt(totalFees.referFee)) / Math.pow(10, 8)} BTC (${(prices.bitcoin * (parseInt(totalFees.serviceFee) + parseInt(totalFees.referFee)) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>

                <div className="w-full border-t-[1px] border-gray-800 my-1"></div>
                <div className="flex flex-row justify-between gap-1">
                  <div>{t('Total Fee')}</div>
                  <div>{totalFees.totalFee / Math.pow(10, 8)} BTC (${(prices.bitcoin * parseInt(totalFees.totalFee) / Math.pow(10, 8)).toFixed(2)})</div>
                </div>
                
              </div> 
            </div>
            <div className="flex flex-row w-full justify-center">
              <button className="bg-primary hover:bg-primary-hover rounded-md py-2 min-w-[240px]" onClick={handleMint}>{t('Mint')}</button>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={show}
        size={"xs"}
        className="bg-background4"
      >
        <DialogHeader>
          {
            inscriptionStatus ? 
              <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 sm:text-[32px] text-[24px] font-bold text-primary relative">
                <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                <span>{t('Mint successful')}.</span>
              </div>
              :
              <div className="flex flex-row w-full justify-center mt-6 sm:text-[32px] text-[24px] font-bold text-primary">
                {t('Minting Now')}
              </div>
          }
        </DialogHeader>
        <DialogBody>
          <div className={`flex flex-col gap-3 w-full ${inscriptionStatus ? 'min-h-[100px]' : 'min-h-[160px]'}`}>
            {
              inscriptionStatus ? 
              <div className="flex flex-col items-center gap-4 relative">
                {/* <div className="flex flex-row justify-center w-full text-[20px] px-2 font-semibold text-green-600 text-center">
                  <CheckCircleIcon strokeWidth={2} className="h-24 w-24" />
                </div> */}
                <div className="w-[180px] mt-5">
                  <Button
                    onClick={() => {
                      setShow(false);
                      setInscriptionStatus(false);
                    }}
                    fullWidth
                  >{t('Close')}</Button>
                </div>
                <img src={cheekyGif} className="w-[100px] h-[100px] rounded-md absolute top-0 right-0"/>
              </div>
              :
              <div className="flex flex-col items-center gap-5">
                <div className="flex flex-row justify-center w-full font-semibold text-[#616161] sm:text-[20px] text-[14px] px-6 text-center">
                  {t('Do Not Close Window Info Message')}
                </div>
                <Spinner className="h-12 w-12" />
              </div>
            }
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
